import React from 'react';
import Radium from 'radium';

class DeleteIcon extends React.Component {
    render() {
        const {
            radius,
            hoverFill,
            style,
        } = this.props;
    
        const diameter = radius * 2;
    
        return (
            <svg
                width={diameter}
                height={diameter}
                viewBox={`0 0 54 54`}
            >
                <g
                    fill="none"
                    fillRule="evenodd"
                    key="delete-icon-hover-listener"
                    style={{
                        ':hover': {}, // attach hover handlers to this element
                        ...style,
                    }}
                >
                    <circle
                        cx={27}
                        cy={27}
                        r={27}
                        style={{
                            fill: Radium.getState(this.state, 'delete-icon-hover-listener', ':hover') ? hoverFill : 'rgba(0,0,0,0.5)',
                        }}
                    />
                    <path
                        fill="#FFF"
                        d="M30.83 36.694V21.898a1.181 1.181 0 0 0-2.361 0v14.796a1.181 1.181 0 0 0 2.361 0zm-5.38 0V21.898a1.181 1.181 0 0 0-2.362 0v14.796a1.181 1.181 0 0 0 2.362 0zm10.667-15.977c-.652 0-1.18.529-1.18 1.18V39.77a.87.87 0 0 1-.868.87H19.851c-.48 0-.87-.39-.87-.87l.001-17.871a1.181 1.181 0 0 0-2.361 0v17.87c0 1.78 1.45 3.232 3.231 3.232H34.07c1.78 0 3.228-1.45 3.228-3.231V21.898a1.18 1.18 0 0 0-1.18-1.18zm2.62-3.679h-5.344v-2.857c0-.652-.53-1.181-1.181-1.181H21.706c-.651 0-1.18.529-1.18 1.18v2.858H15.18a1.181 1.181 0 0 0 0 2.362h23.557a1.181 1.181 0 0 0 0-2.362zm-7.706 0h-8.144v-1.677h8.144v1.677z"
                    />
                </g>
            </svg>
        );
    }
}

export default Radium(DeleteIcon);



// WEBPACK FOOTER //
// ./src/components/icons/DeleteIcon.js